// @ts-nocheck
import { getOnePageCheckoutProductListOverlay } from "@store/Framework/Store/Starter/Components/OnePageCheckoutProductListOverlay/OnePageCheckoutProductListOverlaySelector";
import convertSelectorToHook from "@store/Framework/Common/Utilities/convertSelectorToHook";

export const useOnePageCheckoutProductListOverlay = convertSelectorToHook(getOnePageCheckoutProductListOverlay);
